import React, { useEffect } from 'react';
import { Platform, StatusBar, View } from 'react-native';
import { useTheme } from './theme';
import AppNavigation from './navigation/AppNavigation';
import { OfflineNotice, SyncStatusBanner } from './components/network';
import ErrorBoundary from './components/other/ErrorBoundary';
import useStoreUpdatePrompt from './hooks/useStoreUpdatePrompt';

const App = () => {
	const { theme } = useTheme();
	useStoreUpdatePrompt();

	// Update status bar style based on theme: dark headers need light status
	// icons and vice versa (this was previously inverted).
	useEffect(() => {
		StatusBar.setBarStyle(theme.ui.statusBarStyle);

		if (Platform.OS === 'android') {
			StatusBar.setBackgroundColor(theme.ui.colors.surface);
		}

		// Inject web-specific styles to fix scrolling
		if (Platform.OS === 'web') {
			const style = document.createElement('style');
			style.innerHTML = `
				html, body {
					height: 100%;
					margin: 0;
					padding: 0;
					overflow: hidden;
				}
				#root {
					height: 100vh;
					height: 100dvh;
					display: flex;
					overflow: hidden;
				}
				/* Ensure all flex containers fill height */
				#root > div {
					flex: 1;
					display: flex;
					min-height: 0;
					overflow: hidden;
				}
				/* Force React Native Web ScrollView and FlatList to work properly */
				div[data-testid="ScrollView"], 
				div[data-testid="FlatList"],
				div[class*="css-view"][style*="overflow: hidden"] {
					overflow: auto !important;
				}
				/* Fix for FlatList scroll container */
				div[class*="css-view"][style*="flex: 1"] {
					min-height: 0;
				}
				/* Ensure VirtualizedList works */
				div[data-testid="VirtualizedList"] {
					height: 100%;
				}
			`;
			document.head.appendChild(style);

			return () => {
				document.head.removeChild(style);
			};
		}
	}, [theme]);

	// Use dynamic viewport units on web to avoid clipping behind mobile browser chrome.
	const containerStyle = Platform.OS === 'web' ? { flex: 1, height: '100dvh' } : { flex: 1 };

	return (
		<View style={containerStyle}>
			<ErrorBoundary>
				<AppNavigation />
			</ErrorBoundary>
			<OfflineNotice />
			<SyncStatusBanner />
		</View>
	);
};

export default App;
